import { render } from "./RouterLinkLocale.vue?vue&type=template&id=5c77fcb6"
import script from "./RouterLinkLocale.vue?vue&type=script&lang=js"
export * from "./RouterLinkLocale.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__